/**
 * Recursively flatten VM folders hierarchy
 * @param {Array} vmFolders - Array of VM folder objects
 * @param {string} prefix - Prefix path for nested folders
 * @returns {Array} Flattened array of folders with full paths
 */
export const getRecursiveVmFolders = (vmFolders, prefix = '') => {
    const folders = [];

    if (!vmFolders || !Array.isArray(vmFolders)) {
        return folders;
    }

    vmFolders.forEach((folder) => {
        const name = prefix + folder.name;
        folders.push({
            name: name,
            value: name,
            uuid: folder.uuid,
        });

        if (folder.folders && Array.isArray(folder.folders)) {
            folders.push(...getRecursiveVmFolders(folder.folders, name + '/'));
        }
    });

    return folders;
};

/**
 * Recursively flatten resource pools hierarchy
 * @param {Array} resourcePools - Array of resource pool objects
 * @param {string} prefix - Prefix path for nested pools
 * @returns {Array} Flattened array of resource pools with full paths
 */
export const getRecursiveResourcePools = (resourcePools, prefix = '') => {
    const pools = [];

    if (!resourcePools || !Array.isArray(resourcePools)) {
        return pools;
    }

    resourcePools.forEach((pool) => {
        const name = prefix + pool.name;
        pools.push({
            name: name,
            value: name,
            uuid: pool.uuid,
        });

        if (pool.resource_pools && Array.isArray(pool.resource_pools)) {
            pools.push(...getRecursiveResourcePools(pool.resource_pools, name + '/'));
        }
    });

    return pools;
};
